import { useEffect, useState } from 'react';
import { Category, Tag } from '../../../types/wp';
import { fetchWithType } from '../../../utils/api';
import { KiaStoryOptions } from '../../pages/story/story';
import Snippet from '../Snippet';

interface Props {
  setTestCategory: (category: string | null) => void;
  setTestTag: (tag: string | null) => void;
  setTestHeading: (heading: string) => void;
  setBlockOptions: (
    state: KiaStoryOptions | ((prevState: KiaStoryOptions) => KiaStoryOptions),
  ) => void;
  testTag: string | null;
  testCategory: string | null;
  testHeading: string | null;
  blockOptions: KiaStoryOptions;
}

const StoryFilters = ({
  setTestCategory,
  setTestTag,
  setTestHeading,
  setBlockOptions,
  testTag,
  testCategory,
  testHeading,
  blockOptions,
}: Props) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [tags, setTags] = useState<Tag[]>([]);

  const fetchCategoriesAndTags = async () => {
    const { data, status } = await fetchWithType<{
      data: { categories: { nodes: Category[] }; tags: { nodes: Tag[] } };
    }>('https://kia-blog.live.afonso.se/graphql', {
      method: 'POST',
      body: JSON.stringify({
        query: `
          query getCategoriesAndTags {
            categories(first: 1000, where: {hideEmpty: true}) {
              nodes {
                name
                id
              }
            }
            tags(first: 1000, where: {hideEmpty: true}) {
              nodes {
                name
                id
              }
            }
          }
        `,
        variables: {},
      }),
    });

    if (data?.data && status === 200) {
      setCategories(data.data.categories.nodes);
      setTags(data.data.tags.nodes);
    }
  };

  useEffect(() => {
    fetchCategoriesAndTags();
  }, []);

  const handleSetTestTag = (id: string) => {
    setTestCategory(null);
    setTestTag(id);
  };

  const handleSetTestCategory = (id: string) => {
    setTestTag(null);
    setTestCategory(id);
  };

  const getSnippetProps = () => {
    const props = [];

    if (testHeading) {
      props.push(`heading="${testHeading}"`);
    }

    if (testCategory) {
      props.push(`category="${testCategory}"`);
    } else if (testTag) {
      props.push(`tag="${testTag}"`);
    }

    if (blockOptions?.centerTitle) {
      props.push(`centerTitle="true"`);
    }

    if (blockOptions?.hideTitle) {
      props.push(`hideTitle="true"`);
    }

    return props.join(' ');
  };

  return (
    <div className="pt-2 grid gap-2">
      <label className="grid gap-1 items-center">
        Rubrik
        <input
          type="text"
          placeholder="Ange en rubrik"
          className="border-black border p-2 w-full rounded-sm"
          onChange={(e) => setTestHeading(e.currentTarget.value)}
        />
      </label>
      <div className="grid grid-cols-2 gap-2">
        <label className="grid gap-1 items-center">
          Kategori
          <select
            className="border-black border p-2 w-full rounded-sm"
            onChange={(e) => handleSetTestCategory(e.currentTarget.value)}
            value={testCategory || ''}
          >
            <option value="">Välj kategori</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </label>
        <label className="grid gap-1 items-center">
          Tag
          <select
            className="border-black border p-2 w-full rounded-sm"
            onChange={(e) => handleSetTestTag(e.currentTarget.value)}
            value={testTag || ''}
          >
            <option value="">Välj tag</option>
            {tags.map((tag) => (
              <option key={tag.id} value={tag.id}>
                {tag.name}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="flex gap-8">
        <div className="flex gap-2 items-center">
          <input
            type="checkbox"
            name="center-title"
            id="center-title"
            checked={blockOptions?.centerTitle || false}
            onChange={() =>
              setBlockOptions((prev) => ({
                ...prev,
                centerTitle: !prev.centerTitle,
              }))
            }
          />
          <label htmlFor="center-title">Centrera titeln</label>
        </div>
        <div className="flex gap-2 items-center">
          <input
            type="checkbox"
            name="hide-title"
            id="hide-title"
            checked={blockOptions?.hideTitle || false}
            onChange={() =>
              setBlockOptions((prev) => ({
                ...prev,
                hideTitle: !prev.hideTitle,
              }))
            }
          />
          <label htmlFor="hide-title">Dölja titeln</label>
        </div>
      </div>

      <Snippet page="story" props={getSnippetProps()} />
    </div>
  );
};

export default StoryFilters;
